/**
 * Warstwa API: OSOBY — nazwiska osób już wskazanych w regule widoczności publikacji (S15, 2026-09-14).
 *
 * Trasa backendu: `GET api/users/lookup?ids=1,2,3` — każdy zalogowany, te same filtry co wyszukiwarka
 * (`/users/search`: konta czynne, bez kont niepracowniczych) i MNIEJ pól: samo imię i nazwisko.
 * Konto nieaktywne po prostu nie wraca — wybór odbiorców pokazuje je wtedy jako „Konto nieaktywne (#id)”.
 *
 * Po co: przy EDYCJI zapisanej publikacji wybór odbiorców znał nazwisko wyłącznie osoby dodanej w tej sesji,
 * więc każda wcześniej wskazana osoba była chipem „#17”.
 *
 * Kontrakt: `attach(api)` dostaje instancję axios z apiService.js i zwraca nazwane metody doczepiane do
 * wspólnego `apiService`. Nazwy muszą być unikalne w całej aplikacji (patrz attachApiModules).
 */
export function attach(api) {
    return {
        /** Imiona i nazwiska po identyfikatorach (serwer przyjmuje najwyżej 200 w jednym odczycie). */
        lookupPeople: (ids) => api.get("/users/lookup", { params: { ids: (ids || []).join(",") } }),
    };
}
